<template>
  <div id="profile-change-wrapper">
    <h2 class="my-page-header">お客様情報の確認・編集</h2>
    <p id="profile-complete-message">お客様情報の変更が完了しました</p>
    <div class="button-wrapper">
      <button @click="navigateToTop" class="submit-button top-button round-button">
        マイページTOPへ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPageModifyProfileComplete',
  methods: {
    navigateToTop() {
      this.$emit('updated', 'top');
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/style/parts_responsive.scss";

#profile-complete-message {
  padding: 90px 30px;
  text-align: center;
  font-size: 16px;
}

.button-wrapper {
  display: flex;
  height: 200px;
}

@media (min-width: 640px) {
  #profile-change-wrapper {
    border: 1px solid #CCCCCC;
    border-radius: 14px;
    background-color: white;
    margin: auto;
    padding: 28px;
    height: 385px;
    width: 720px;
    margin-bottom: 100px;
  }
}
</style>
